import { defineStyle, defineStyleConfig } from '@chakra-ui/styled-system';

const outline = defineStyle({
  bg: 'bg.input',
  color: 'text.primary',
  borderColor: 'border.muted',
  transitionProperty: 'common',
  transitionDuration: 'normal',
  // Ensure at least 16px font-size to prevent iOS Safari from auto-zooming on focus
  fontSize: '16px',
  _placeholder: {
    color: 'text.placeholder',
  },
  _hover: {
    borderColor: 'border.emphasized',
    bg: 'bg.input',
  },
  _focusVisible: {
    borderColor: 'accent.default',
    boxShadow: '0 0 0 1px var(--chakra-colors-accent-default)',
  },
  _invalid: {
    borderColor: 'critical.text',
    boxShadow: '0 0 0 1px var(--chakra-colors-critical-text)',
  },
  _disabled: {
    opacity: 1,
    bg: 'bg.disabled',
    color: 'text.muted',
    cursor: 'not-allowed',
    borderColor: 'border.muted',
    _placeholder: {
      color: 'text.muted',
    },
  },
});

export const Textarea = defineStyleConfig({
  variants: { outline },
  defaultProps: {
    variant: 'outline',
    size: 'md',
  },
});
